import { Dialog, DialogContent, DialogTitle, DialogDescription } from 'components/ui/dialog';
import { Button } from 'components/ui/button';
import Text from 'components/Text';
import { fontSizes } from 'appconstants';

interface SuccessDialogProps {
  open: boolean;
  onContinue: () => void;
}

const SuccessDialog = ({
  open,
  onContinue,
}: SuccessDialogProps) => {
  return (
    <Dialog open={open} onOpenChange={onContinue}>
      <DialogContent className="max-w-[420px] rounded-2xl text-center p-6">
        <DialogTitle>
          <Text
            text='Labels Updated!'
            size={fontSizes.h20}
            className="font-bold"
          />
        </DialogTitle>

        <DialogDescription>
          <Text
            text={'The form labels have been updated successfully.'}
            size={fontSizes.h14}
            className="text-muted-foreground"
          />
        </DialogDescription>

        <Button
          onClick={onContinue}
        >
          Continue
        </Button>
      </DialogContent>
    </Dialog>
  );
};

export default SuccessDialog;
